import React from "react";

const DashboardCard = ({ children, className = "" }) => {
  return (
    <section
      className={`rounded-xl border border-customAccentBlue/15 bg-white shadow-sm shadow-customAccentBlue/5 dark:border-customBorder dark:bg-customSurface ${className}`}
    >
      {children}
    </section>
  );
};

export default DashboardCard;
